export default __webpack_public_path__ + "static/media/P10007.72d6fbcf.png";